import { useNavigate } from 'react-router-dom'
import { Button } from '../Button'
import { WarningIcon } from '../../icons/support'
import { useTranslation } from 'react-i18next'

function ForbiddenPage() {
  const { t: translate } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="h-full flex flex-col items-center justify-center">
      <WarningIcon className="text-4xl text-primary-600 mb-5" />
      <h1 className="text-3xl font-medium text-gray-800 mb-1">
        {translate('access_denied')}
      </h1>
      <div className="text-gray-600 mb-4">
        {translate('you_do_not_have_permission_to_view_this_page')}
      </div>

      <Button
        className="mt-4"
        onClick={() => {
          navigate(-1)
        }}
      >
        {translate('back_to_previous_page')}
      </Button>
    </div>
  )
}

export default ForbiddenPage
